import React from 'react';
import PropTypes from 'prop-types';

export default function CreateListingMessage({ deal }) {
  return <React.Fragment>
    <p>
      A new listing will be created as a <b>draft</b>,
      with <b>{deal.brokers[0].name}</b> as the primary broker.
    </p>

    <p>
      Property {deal.dealType === 'lease' ? 'and lease space' : '' } information
      will be copied from this deal to the listing.
    </p>
  </React.Fragment>;
}

CreateListingMessage.propTypes = {
  deal: PropTypes.shape({
    brokers: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
    })).isRequired,
    dealType: PropTypes.string.isRequired,
  }).isRequired,
};
